import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Oee extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'oee';
  label = 'OEE';
}

export default Oee;
